import {Injectable} from '@angular/core';
import {CheckListStrategy} from './check-list.strategy';
import {CheckpointType} from '../../../data/checkpoint-type.enum';
import {CheckpointStage} from '../../../data/checkpoint-stage.enum';
import {Checkpoint} from '../../../data/checkpoint.model';

@Injectable()
export class InternalTestCheckListStrategy implements CheckListStrategy {

  availableTypes: CheckpointType[] = [CheckpointType.Test];
  stage = CheckpointStage.Softline;
  getDefaultValue(): Partial<Checkpoint> {
    return {
      type: CheckpointType.Test
    };
  }
}
